// Components==============
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { GrowthPortfolioContext } from 'pages/Growth/GrowthPortfolio/GrowthPortfolio';
import React, { useContext } from 'react';
import { framerMountAndScale } from 'utilities/FramerAnimations';
import './Skills.module.scss';
// =========================

const Card = ({
  skill,
  dir,
}: {
  skill: SkillEntity;
  dir: 'left' | 'right';
}) => {
  const framer = {
    initial: { rotateY: 0, opacity: 0 },
    animate: {
      rotateY: dir === 'left' ? 20 : -20,
      opacity: 1,
    },
    whileHover: { rotateY: 0 },
    whileTap: { rotateY: 0, scale: 0.97 },
  };

  const translate = useTranslate();
  const { setSelected } = useContext(GrowthPortfolioContext);

  return (
    <motion.div
      styleName={`skill ${dir}`}
      {...framer}
      onClick={() => setSelected('general.terms.skills')}
    >
      <h2>{skill.name}</h2>
      <div styleName="icons">
        <img
          src={`/storage/${skill.icon}`}
          alt={skill.name}
          styleName="skill-icon"
        />
        <img
          src={
            dir === 'left' ? '/images/bad-skill.png' : '/images/good-skill.png'
          }
          alt="icon"
          styleName="icon"
        />
      </div>
      <p styleName="description">
        {dir === 'left'
          ? translate('reflection.skill-description.bad.start')
          : translate('reflection.skill-description.good.start')}{' '}
        {skill.name}{' '}
        {dir === 'left'
          ? translate('reflection.skill-description.bad.end')
          : translate('reflection.skill-description.good.end')}{' '}
      </p>
    </motion.div>
  );
};

export default function Skills() {
  const skills = useRedux((state) => {
    const skillData = state.authentication?.user.skill_data?.sort(
      (a, b) => a.percentage - b.percentage
    );

    const noData = skillData?.find((d) => d.percentage !== 0) === undefined;
    if (noData) return undefined;

    return skillData?.map((skill) => state.skill?.entities.byId[skill.id]);
  });

  const { setSelected } = useContext(GrowthPortfolioContext);
  const translate = useTranslate();

  const badSkill = skills?.[0];
  const goodSkill = skills?.[skills.length - 1];

  return (
    <div styleName="box">
      <div styleName="wrapper">
        <div styleName="skills">
          {!skills ? (
            <motion.div
              {...framerMountAndScale}
              onClick={() => setSelected('general.terms.skills')}
              styleName="placeholder"
            >
              <img
                src="/images/vaardigheden-default.svg"
                alt="default skills"
              />
            </motion.div>
          ) : (
            <>
              {!!badSkill && <Card skill={badSkill} dir="left" />}
              {!!goodSkill && <Card skill={goodSkill} dir="right" />}
            </>
          )}
        </div>
        <h3>{translate('general.terms.skills')}</h3>
      </div>
    </div>
  );
}
